<h4>Ändern Sie Ihr Passwort</h4>
<p>
  Um Ihr Passwort mit sofortiger Wirkung zu ändern ist es notwendig, dass Sie
  Ihre altes Passwort eingeben. Dann können Sie Ihr neues Passwort wählen. Die
  geschätzte Stärke Ihres neuen Passworts wird Ihnen bei Eingabe angezeigt.
</p>
<p>
  Es gilt ein verpflichtendes Sicherheitsniveau. Dieses sieht vor, dass Ihr
  Passwort bestimmte Elemente nicht enthalten darf. Darunter fallen
  beispielsweise Ihr Vorname, Nachname und weitere Ihrer Daten. Die Auflistung
  sehen Sie unten unter der Eingabe Ihres neuen Passworts. Die roten unerfüllten
  Eigenschaften werden grün dargestellt sobald sie erfüllt werden.
</p>
<form [formGroup]="changeForm" class="container">
  <input [value]="userData.username" autocomplete="username" type="hidden"/>
  <div class="row">
    <div class="col-12">
      <label>
        Ihr altes Passwort
        <input
          autocomplete="current-password"
          class="form-control"
          formControlName="old_password"
          placeholder="Ihr altes Passwort"
          type="password"
        />
      </label>
      <san-form-input-error
        [visible]="
          changeForm.get('old_password').dirty &&
          changeForm.get('old_password').errors?.required
        "
        message="Das alte Passwort muss eingegeben werden"
      ></san-form-input-error>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <label>
        Ihr neues Passwort
        <input
          (ngModelChange)="recalculatePasswordStrength()"
          autocomplete="new-password"
          class="form-control"
          formControlName="new_password"
          placeholder="Ihr neues Passwort"
          type="password"
        />
      </label>
      <san-form-input-error
        [visible]="
          changeForm.get('new_password').dirty &&
          changeForm.get('new_password').errors?.required
        "
        message="Das neue Passwort muss eingegeben werden"
      ></san-form-input-error>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <ul class="small list-unstyled d-block">
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.minlength,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.minlength,
          }"
        >
          Mindestens 8 Zeichen
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.enthaeltZiffer,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.enthaeltZiffer,
          }"
        >
          Mindestens 1 Zahl
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.enthaeltSonderzeichen,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.enthaeltSonderzeichen,
          }"
        >
          Mindestens 1 Sonderzeichen
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.enthaeltKleinbuchstabe,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.enthaeltKleinbuchstabe,
          }"
        >
          Mindestens 1 Kleinbuchstabe
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.enthaeltGrossbuchstabe,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.enthaeltGrossbuchstabe,
          }"
        >
          Mindestens 1 Großbuchstabe
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.enthaeltNichtEmail,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.enthaeltNichtEmail,
          }"
        >
          Darf nicht die E-Mail Adresse enthalten
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors
                ?.enthaeltNichtVornameNachname,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors
                ?.enthaeltNichtVornameNachname,
          }"
        >
          Darf nicht den Vor- oder Nachnamen enthalten
        </li>
        <li
          [ngClass]="{
            'text-danger':
              !changeForm.controls.new_password.value ||
              changeForm.controls.new_password.errors?.enthaeltNichtLanrBsnr,
            'text-success':
              changeForm.controls.new_password.value &&
              !changeForm.controls.new_password.errors?.enthaeltNichtLanrBsnr,
          }"
        >
          Darf nicht die LANR oder BSNR enthalten
        </li>
      </ul>
      <ngb-progressbar
        [value]="passwordStrength?.score"
        class="mt-1 d-block"
        max="4"
      ></ngb-progressbar>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <label>
        Wiederholen Sie Ihr neues Passwort
        <input
          autocomplete="new-password"
          class="form-control"
          formControlName="new_password_2"
          placeholder="Ihr neues Passwort (Wiederholung)"
          type="password"
        />
      </label>
      <san-form-input-error
        [visible]="
          changeForm.get('new_password_2').dirty &&
          changeForm.get('new_password_2').errors?.required
        "
        message="Das neue Passwort muss erneut eingegeben werden"
      ></san-form-input-error>
      <san-form-input-error
        [visible]="
          changeForm.get('new_password_2').dirty &&
          changeForm.get('new_password_2').errors?.match
        "
        message="Die Passwörter stimmen nicht überein"
      ></san-form-input-error>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <button
        (click)="savePassword()"
        [disabled]="transmitting"
        class="btn btn-primary"
      >
        Passwort ändern<span *ngIf="transmitting"
      >&nbsp;<fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon
      ></span>
      </button>
    </div>
  </div>
</form>

<ng-template #confirmLogoutOthersModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Von anderen Geräten abmelden?</h4>
    <button (click)="modal.dismiss()" aria-label="Close" class="btn-close" type="button"></button>
  </div>
  <div class="modal-body">
    <p>
      Möchten Sie von allen anderen Geräten abgemeldet werden? Ihre aktuelle
      Sitzung bleibt bestehen.
    </p>
  </div>
  <div class="modal-footer">
    <button (click)="modal.close(false)" class="btn btn-secondary" type="button">
      Nein, nur Passwort ändern
    </button>
    <button (click)="modal.close(true)" class="btn btn-primary" type="button">
      Ja, überall abmelden
    </button>
  </div>
</ng-template>
